import ToastComponent from '../components/loading.vue';
import Toast from './toast';
import vue from 'vue';
const Loading = {};

// 注册Toast
Loading.install = function(Vue) {
	// 生成一个Vue的子类
	// 同时这个子类也就是组件
	const ToastConstructor = Vue.extend(ToastComponent);
	// 生成一个该子类的实例
	const instance = new ToastConstructor();

	// 将这个实例挂载在我创建的div上
	// 并将此div加入全局挂载点内部
	instance.$mount(document.createElement('div'));
	document.body.appendChild(instance.$el);

	// 通过Vue的原型注册一个方法
	// 让所有实例共享这个方法
	Vue.prototype.$loading = (msg, duration = 10000) => {
		instance.message = msg;
		if (msg) {
			instance.visible = true;
			instance.timer && clearTimeout(instance.timer);
			instance.timer = setTimeout(() => {
				if (instance.visible === true) {
					instance.visible = false;
					instance.$toast('加载失败，请重试');
				}
				// msg = '请求超时'
			}, duration);
		} else {
			instance.visible = false;
		}
	};
};

export default Loading;



// WEBPACK FOOTER //
// ./src/js/loadingx.js